export default "__VITE_ASSET__CKqX9Ua3__"